
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.588 37.067a.937.937 0 01-.941.933.937.937 0 01-.941-.933v-13.2c0-.175.05-.347.143-.495l8.51-15.505H9.017l11.81 15.385a.93.93 0 01.232.615v9.466a.937.937 0 01-.941.934.937.937 0 01-.941-.934v-9.116L6.235 7.547C5.702 6.945 6.135 6 6.943 6h30.114c.74 0 1.19.806.798 1.428l-9.267 16.706v12.933z"}})])
          )
        }
      }
    